// Hide success message on modal close 
$( '.uk-modal-close-default' ).on( 'click', function(e) {
	e.preventDefault();

	$( ".gform_fields li.frm-msg" ).hide();
} );
 
// When esc key is pressed
$( document ).on( 'keyup', function(e) {
	if( e.which === 27 ) {
		e.preventDefault();

		$( ".gform_fields li.frm-msg" ).hide();
	}
} );
 
function fileSelect() {
	var filename = $( 'input[type=file]' ).val().replace( /C:\\fakepath\\/i, '' );
    
	$( ".filenameform span" ).html( filename );
    
	// console.log(filename);
}
 
$( function () {
  //  $( "#selectstorename" ).change( function() {
	// 	var storename  = $( this ).children( ":selected" ).attr( "value");
	// 	var storeemail = $( this ).children( ":selected" ).attr( "dataemail");

  //        $(".input_storeName").val(storename);
  //        $(".input_storeEmail").val(storeemail);
  //     /*}*/
  // });

	$( 'form.jotform-form' ).on( 'submit', function(e) {
		e.preventDefault();

		var filenameval = $( 'input[type=file]' ).val().toLowerCase();
		var formdata 		= new FormData( $( "#203295442381252" ).get(0) );

		$( '.raq-form-submission-loader-container' ).removeAttr( 'hidden' );
			
		// Display location alert if a store hasn't been selected
		if( $( '#input_24' ).val() === '' || $( '#input_25' ).val() === '' ) {
			$( '.raq-form-submission-loader-container' ).attr( 'hidden', true );
			$( '.form-location-alert-container' ).removeAttr( 'hidden' );
			
			return false;
		}			

		else {
			$( '.form-location-alert-container' ).hide();
		}

		// Show error on checkbox if not checked
		if( $( '#input_20_0' ).is( ':checked' ) ) {
			$( '#input_20_0' ).css( { 'border-color': '#c2c2c2' } );
		}
		
		else {
			$( '.raq-form-submission-loader-container' ).attr( 'hidden', true );
			$( '#input_20_0' ).css( { 'border-color': 'red' } );
			
			return false;
		}
    
		if( filenameval !== "" ) {
			regexfile = new RegExp( "(.*?)\.(docx|doc|pdf|xml|jpg|png|ppt|xls)$" );
         
			if( !( regexfile.test( filenameval ) ) ) {
				$( '.raq-form-submission-loader-container' ).attr( 'hidden', true );
				$( ".gformfile span.error" ).html( 'Please select correct file format' );
            
				return false;
      }
			
			else {
				$( ".gformfile span.error" ).html( '' );
			}
		}
		
		else {
			$( ".gformfile span.error" ).html( '' );
			$( 'input[type=file]' ).val( '' );
		}          
      
		$( '#input_7' ).attr( 'disabled', 'disabled' );

		// Test form without submission
		// setTimeout( () => {
		// 	$( '.raq-form-submission-loader-container' ).attr( 'hidden', true );
		// 	$( '.frm-msg' ).css( "display", "block" );
		// 	return false;
		// }, 3000 );
      
		$.ajax( {
			type: 'post',
			url: 'https://submit.jotform.com/submit/203295442381252/',
			data: formdata,
			processData: false,
			contentType: false,
			
			success: function( data ) {
				dataLayer.push( {
					'event': 'rfq-submission',
				} );
					
				$( '.raq-form-submission-loader-container' ).hide();
				$( '.frm-msg' ).css( "display", "block" );
				$( "form.jotform-form input" ).val( '' );
				$( 'form.jotform-form textarea' ).val( '' ).empty();
				$( 'form.jotform-form .filenameform span' ).html( '' );
				$( "form.jotform-form #selectstorename" ).val( '' );

				$( '#input_7' ).removeAttr( 'disabled' );
			},
        
			error: function(e) {
				// console.log(e)
			}
		} );
      
		return false;
	} );
} );
